import { action } from '@sas/nova-commons/action';
import { createReducer } from '../utils/action/createReducer';
const AT = {
    Set: 'explanation/set',
    Update: 'explanation/update',
    Reset: 'explanation/reset',
};
export const ExplanationState = {
    elementName: 'explanation',
    actionTypes: AT,
    actions: {
        set: (data) => action(AT.Set, data),
        update: (data) => action(AT.Update, data),
        reset: () => action(AT.Reset),
    },
    reducer: createReducer({}, {
        [AT.Set](_state, action) {
            return action.payload;
        },
        [AT.Update](state, action) {
            return Object.assign(Object.assign({}, state), action.payload);
        },
        [AT.Reset](_state) {
            return {};
        },
    }),
};
